import { CloseButton, MantineSize, NumberInput } from "@mantine/core";
import { BaseSelectStylesNames } from "@mantine/core/lib/Select/types";
import { IconPercentage } from "@tabler/icons";
import { useField } from ".";

type Props = {
  name: string;
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  noError?: boolean;
  hideControls?: boolean;
  classNames?: Partial<Record<BaseSelectStylesNames, string>> | undefined;
  onChangeCustom?: any;
  size?: MantineSize;
  min?: number;
  max?: number;
  iconWidth?: any;
  maxLength?: number;
  required?: boolean;
  formatter?: any;
  parser?: any;
  rightSection?: React.ReactNode;
  precision?: number;
  allowArrow?: boolean;
};

export function NumberPercentField({
  name,
  label,
  noError = false,
  hideControls = false,
  placeholder,
  disabled = false,
  classNames,
  onChangeCustom,
  size = "sm",
  min,
  max,
  iconWidth,
  maxLength,
  required,
  allowArrow,
  precision = 2, // Default precision of 2 decimal places
}: Props) {
  const { value, error, onChange } = useField(name);

  return (
    <NumberInput
      maxLength={maxLength}
      iconWidth={iconWidth}
      max={max}
      min={min}
      size={size}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      value={value || undefined}
      hideControls={hideControls}
      onChange={(v) => {
        const formattedValue = v ? parseFloat(v.toFixed(precision)) : v;
        onChange(formattedValue);
        onChangeCustom && onChangeCustom(formattedValue);
      }}
      classNames={classNames}
      styles={{
        error: {
          display: noError ? "none" : "block",
        },
        wrapper: {
          marginBottom: error && !noError ? "10px" : "0",
        },
      }}
      required={required}
      precision={typeof value === "number" ? precision : undefined}
      rightSection={
        !allowArrow && (
          <CloseButton
            onClick={() => {
              onChange("");
              onChangeCustom && onChangeCustom(undefined);
            }}
            variant="transparent"
            size={"sm"}
            color="gray.6"
          />
        )
      }
      parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
      icon={<IconPercentage size={18} stroke="1.5" color="gray" opacity={0.8} />}
    />
  );
}
